const base = {
  weeks: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  test: function () {
    console.log('test')
  },
  /**
   * 删除数组内指定索引的元素
   * @param {*} delIndex 索引
   * @param {*} that 数组本身
   * @return {Array} 删除后的数组
   */
  arrDelete: function (delIndex, that) {
    var temArray = []
    for (var i = 0; i < that.length; i++) {
      if (i !== delIndex) {
        temArray.push(that[i])
      }
    }
    return temArray
  },
  /**
   * 格式化时间
   * @param {*} fmt 格式 eg:'yyyy-MM-dd'
   * @param {*} that Date本身
   * @return {Date} 格式化的时间
   */
  dateFormat: function (fmt, that) {
    var o = {
      'M+': that.getMonth() + 1, // 月份
      'd+': that.getDate(), // 日
      'h+': that.getHours(), // 小时
      'm+': that.getMinutes(), // 分
      's+': that.getSeconds(), // 秒
      'q+': Math.floor((that.getMonth() + 3) / 3), // 季度
      S: that.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (that.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  },
  /**
   * 获取html的纯文本
   * @param {*} html HTML代码块
   * @return 纯文本
   */
  getSimpleText: function (html) {
    var re1 = new RegExp('<.+?>', 'g')
    var msg = html.replace(re1, '')
    return msg
  },
  /**
   * 获取不包含span标签的html
   * @param {*} html HTML代码块
   * @return html
   */
  getSpanText: function (html) {
    var re2 = new RegExp('(<|</)(?!(span)[ >])[^>/]*>', 'g')
    var msg2 = html.replace(re2, '')
    console.log(msg2)
    return msg2
  },
  /**
   * 滚动到锚点
   * @param {*} dom 锚点
   */
  scorllToHref: function (dom) {
    if (dom) {
      let anchor = document.querySelector(dom)
      document.documentElement.scrollTop = anchor.offsetTop > 80 ? anchor.offsetTop - 80 : anchor.offsetTop
    } else {
      document.documentElement.scrollTop = 0
    }
  },
  /**
   * 去除空格
   * @param {*} str 需要去除的字符串
   * @param {*} global 正则标准
   */
  trim: function (str, global) {
    var result
    result = str.replace(/(^\s+)|(\s+$)/g, '')
    if (global.toLowerCase() === 'g') {
      result = result.replace(/\s/g, '')
    }
    return result
  },
  /**
   * 获取n天前/后的时间
   * @param {*} day +-天数（+代表后day天，-代表前day天）
   */
  getDay: function (day) {
    var today = new Date()

    var targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day

    today.setTime(targetdayMilliseconds) // 注意，这行是关键代码

    var tYear = today.getFullYear()
    var tMonth = today.getMonth()
    var tDate = today.getDate()
    var tDay = this.weeks[today.getDay()]

    tMonth = this.doHandleMonth(tMonth + 1)
    tDate = this.doHandleMonth(tDate)
    return tYear + '-' + tMonth + '-' + tDate + '（' + tDay + '）'
  },
  /**
   * 给个位数月份前添加0
   * @param {*} month 要格式化的月份
   */
  doHandleMonth: function (month) {
    var m = month
    if (month.toString().length === 1) {
      m = '0' + month
    }
    return m
  },
  isImg: function (url) {
    var temp = []
    temp = url.toString().split('.')
    if (temp[temp.length - 1].toLowerCase() === 'png' || temp[temp.length - 1].toLowerCase() === 'jpg') {
      return true
    } else {
      return false
    }
  },
  isContain: function (value, str) {
    if (value.indexOf(str) > -1) {
      return true
    } else {
      return false
    }
  },
  reg: {
    idCard: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
    phone: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
    email: /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
  },
  defaultTxt: {
    upload_tips: '支持jpg/png格式，<5M <br/>推荐分辨率800*800px',
    upload_bg_tips: '支持mp3、wmv、<br/>wma格式，<5M '
  }
}
export { base }



// WEBPACK FOOTER //
// ./src/utils/base.js